import React from 'react';
import PropTypes from 'prop-types';
import { mediaTypes } from 'components/posts';
import { generateBemCss } from 'general/js/helpers';
import { ContentType } from 'components/content-type';
import { routeToHoleModal } from 'components/route-to-hole-modal';
import { hasValue } from '../../../general/js/general-helpers';
import {
    getR2hThumbnailSrc,
    getLiveBlogRouteToHoleConfig
} from '../../route-to-hole-player/js/route-to-hole-helpers';

const ROOT_CLASS = 'clip-tag-post';
class ClipTagPost extends React.Component {
    constructor(...args) {
        super(...args);

        this.onClickRoot = this.onClickRoot.bind(this);
    }

    onClickRoot() {
        const { model, config } = this.props;

        if (!hasValue(config) || !hasValue(model.videoId)) return;

        routeToHoleModal.show(model, config);
    }

    render() {
        const { model, config } = this.props;
        const bemCss = generateBemCss(ROOT_CLASS, [mediaTypes.VIDEO]);
        const thumbnailSrc = hasValue(model) ? getR2hThumbnailSrc(model.videoId, getLiveBlogRouteToHoleConfig(config)) : null;

        return (
            <a
                className={bemCss}
                target="_blank"
                rel="noopener noreferrer"
                onClick={this.onClickRoot}
            >
                <div className={`${ROOT_CLASS}__content-type`}>
                    <ContentType type={mediaTypes.VIDEO_PLAYER} />
                </div>
                <div className={`${ROOT_CLASS}__bg`}>

                    <img
                        key={model.overrideSrc || thumbnailSrc}
                        className="lazyload"
                        data-srcset={model.overrideSrc || thumbnailSrc}
                        alt=""
                    />
                </div>
                <div className={`${ROOT_CLASS}__content`}>
                    <h3 className={`${ROOT_CLASS}__title`}>{model.title}</h3>
                    {
                        model.body &&
                        <div
                            className={`${ROOT_CLASS}__body`}
                            dangerouslySetInnerHTML={{ __html: model.body }}
                        />
                    }
                </div>
            </a>
        );
    }
}

ClipTagPost.propTypes = {
    model: PropTypes.object.isRequired,
    config: PropTypes.object
};

export default ClipTagPost;
